import { Injectable } from '@angular/core';
import { BaseAccessService } from '@zaoblako/web/core/models/enums/access-rules/base-access.service';
import { CctvAccessRulesKeyEnum } from './cctv-access-rules-key.enum';
import { CctvAccessRulesConst } from './cctv-access-rules.const';

@Injectable({
  providedIn: 'root'
})
export class CctvAccessService extends BaseAccessService<CctvAccessRulesKeyEnum> {
  public constructor() {
    super(CctvAccessRulesConst);
  }

  public get parkingRights() {
    return {
      canReadSettings: this.globalService.isAccessRule(
        CctvAccessRulesConst[CctvAccessRulesKeyEnum.CCTV_PARKING_SETTINGS_READ]
      ),
      canWriteSettings: this.globalService.isAccessRule(
        CctvAccessRulesConst[CctvAccessRulesKeyEnum.CCTV_PARKING_SETTINGS_WRITE]
      ),
      canReadCarCategory: this.globalService.isAccessRule(
        CctvAccessRulesConst[CctvAccessRulesKeyEnum.CCTV_PARKING_CAR_CATEGORY_READ]
      ),
      canWriteCarCategory: this.globalService.isAccessRule(
        CctvAccessRulesConst[CctvAccessRulesKeyEnum.CCTV_PARKING_CAR_CATEGORY_WRITE]
      ),
      canReadTransitTask: this.globalService.isAccessRule(
        CctvAccessRulesConst[CctvAccessRulesKeyEnum.CCTV_PARKING_TRANSIT_TASK_READ]
      ),
      canWriteTransitTask: this.globalService.isAccessRule(
        CctvAccessRulesConst[CctvAccessRulesKeyEnum.CCTV_PARKING_TRANSIT_TASK_WRITE]
      ),

      canReadResidentCar: this.globalService.isAccessRule(
        CctvAccessRulesConst[CctvAccessRulesKeyEnum.CCTV_PARKING_RESIDENT_CAR_READ]
      ),
      canWriteResidentCar: this.globalService.isAccessRule(
        CctvAccessRulesConst[CctvAccessRulesKeyEnum.CCTV_PARKING_RESIDENT_CAR_WRITE]
      ),

      canReadHikvisionCamera: this.globalService.isAccessRule(
        CctvAccessRulesConst[CctvAccessRulesKeyEnum.CCTV_PARKING_HIKVISION_CAMERA_READ]
      ),
      canWriteHikvisionCamera: this.globalService.isAccessRule(
        CctvAccessRulesConst[CctvAccessRulesKeyEnum.CCTV_PARKING_HIKVISION_CAMERA_WRITE]
      ),

      canReadReports: this.globalService.isAccessRule(
        CctvAccessRulesConst[CctvAccessRulesKeyEnum.CCTV_PARKING_REPORTS_READ]
      ),
      canWriteReports: this.globalService.isAccessRule(
        CctvAccessRulesConst[CctvAccessRulesKeyEnum.CCTV_PARKING_REPORTS_WRITE]
      )
    };
  }

  public get parkingPermissions() {
    return {
      canBlockParking: this.globalService.isAccessRule(
        CctvAccessRulesConst[CctvAccessRulesKeyEnum.CCTV_PARKING_CAN_BLOCK_PARKING]
      ),
      canDeleteActiveTransitTask: this.globalService.isAccessRule(
        CctvAccessRulesConst[CctvAccessRulesKeyEnum.CCTV_PARKING_CAN_DELETE_ACTIVE_TRANSIT_TASK]
      ),
      canUnlinkTransitTaskEvent: this.globalService.isAccessRule(
        CctvAccessRulesConst[CctvAccessRulesKeyEnum.CCTV_PARKING_CAN_UNLINK_TRANSIT_TASK_EVENT]
      ),
      canAccessToAllTransitTask: this.globalService.isAccessRule(
        CctvAccessRulesConst[CctvAccessRulesKeyEnum.CCTV_PARKING_ACCESS_TO_ALL_TRANSIT_TASK]
      ),
      canManualOpen: this.globalService.isAccessRule(
        CctvAccessRulesConst[CctvAccessRulesKeyEnum.CCTV_PARKING_MANUAL_OPEN]
      ),
      canEditEvent: this.globalService.isAccessRule(
        CctvAccessRulesConst[CctvAccessRulesKeyEnum.CCTV_PARKING_EDIT_EVENT]
      )
    };
  }
}
